import { setSelectedSideMenu } from "../../sideMenuDropdown/sideMenuDropdown";

export const getSelectedSideMenu = (
  sideMenuIndex = null,
  subMenuIndex = null
) => {
  return async (dispatch, store) => {
    const data = {};

    if (sideMenuIndex !== undefined) {
      data.sideMenuIndex = sideMenuIndex;
    }

    if (subMenuIndex !== undefined) {
      data.subMenuIndex = subMenuIndex;
    }
    dispatch(setSelectedSideMenu(data));
  };
};
